import Alert from '~/components/Alert';
import Submit from '~/components/button/Submit';
import CustomerInfoFields from '~/components/CustomerInfoFields';
import Form from '~/components/Form';
import Page from '~/components/layout/page/Page';
import { useActionResult, useLoaderData } from './editAddress';

export default function EditAddressPage() {
  const { customerInfo, requirePhone, isShippingProtectionClaim } =
    useLoaderData();
  const actionResult = useActionResult();

  return (
    <Page.Root title="Update Address">
      <Form name="addressForm">
        <CustomerInfoFields
          omitEmail={isShippingProtectionClaim}
          info={customerInfo}
          requirePhone={requirePhone}
        />
        {actionResult?.ok === false && (
          <Alert variant="error" title="Invalid address">
            Please check your information is correct.
          </Alert>
        )}
        <Submit>Next</Submit>
      </Form>
    </Page.Root>
  );
}
